import { Injectable } from '@angular/core';

import { EventPage, EventType, GA4Event, GTMService } from '@personal-area/global/gtm';

@Injectable()
export class ProfileTrackingService {

  constructor(private _gtmService: GTMService) {}

  public passwordInputChanged(): void {
    this._gtmService.event(EventType.IDInputUpdated, <GA4Event>{
      page_name: EventPage.VerificationId,
      context: 'verifyId',
      object: 'idInput',
      action: 'updated'
    });
  }

  public passportInputError(): void {
    this._gtmService.event(EventType.IDWarningViewed, <GA4Event>{
      page_name: EventPage.VerificationId,
      context: 'verifyId',
      object: 'idWarning',
      action: 'updated'
    });
  }

  public birthDateInputChanged(): void {
    this._gtmService.event(EventType.BirthdateInputUpdated, <GA4Event>{
      page_name: EventPage.VerificationId,
      context: 'verifyId',
      object: 'birthdateInput',
      action: 'updated'
    });
  }

  public uploadDocumentTapped(): void {
    this._gtmService.event(EventType.FileUploadTapped, <GA4Event>{
      page_name: EventPage.VerificationId,
      context: 'verifyId',
      object: 'fileUpload',
      action: 'tapped',
    });
  }

  public uploadDocumentStart(): void {
    this._gtmService.event(EventType.FileUploadStarted, <GA4Event>{
      page_name: EventPage.VerificationId,
      context: 'verifyId',
      object: 'fileUpload',
      action: 'started'
    });
  }

  public uploadDocumentEnd(): void {
    this._gtmService.event(EventType.FileUploadFinished, <GA4Event>{
      page_name: EventPage.VerificationId,
      context: 'verifyId',
      object: 'fileUpload',
      action: 'finished'
    });
  }

  public clickEuAgreement(): void {
    this._gtmService.event(EventType.EuAgreementButtonTapped, {
      context: 'profile',
      action: 'tapped',
      object: 'euAgreementButton',
    });
  }
}
